import { useEventListener } from '@grandvisionhq/utils';

const cartChangEventType = 'cart.change';
const dispatchCartChangeEvent = (cartId)=>{
    if (window) {
        window.dispatchEvent(new CustomEvent(cartChangEventType, {
            detail: {
                cartId
            }
        }));
    }
};
const useCartChangeListener = (handler)=>{
    return useEventListener(cartChangEventType, handler);
};

export { cartChangEventType, dispatchCartChangeEvent, useCartChangeListener };
//# sourceMappingURL=use-cart-change-listener.js.map
